// todo: consolidate this form and the one in react-sso-landing

import React, {Component} from 'react';
import ChangePasswordForm from './changePasswordForm/ChangePasswordForm'
import CognitoPasswordValidator from "./changePasswordForm/CognitoPasswordValidator";
import {connect} from "react-redux";
import {loginWatcher} from "../redux/actions/loginactioncreators";
import {bindActionCreators} from "redux";
import PropTypes from 'prop-types';
import challengeShape from "../proptypes/challengeShape";
import flowStages from "../flowStages";

export class ChangePassword extends Component {
  handleSubmit = (params) => {
    const flowStage = this.props.challenge.challengeName === flowStages.EXPIRED_NEW_PASSWORD_REQUIRED ? flowStages.EXPIRED_NEW_PASSWORD_REQUIRED : flowStages.CHALLENGE
    this.props.loginWatcher({
      flowStage: flowStage,
      challengeResponse: {
        session: this.props.challenge.session,
        challengeName: this.props.challenge.challengeName,
        challengeParameters: {
          USERNAME: this.props.challenge.challengeParameters.USER_ID_FOR_SRP,
          OLD_PASSWORD: params.oldPassword.trim(),
          NEW_PASSWORD: params.newPassword.trim()
        }
      },
      username: this.props.username,
    });
  }

  render() {
    return (
      <ChangePasswordForm
        onSubmit={this.handleSubmit}
        passwordValidator={
          new CognitoPasswordValidator(8, 99, true, true, true, true)
        }
      />
    )
  }
}

ChangePassword.propTypes = {
  loginWatcher: PropTypes.func.isRequired,
  challenge: challengeShape,
  username: PropTypes.string.isRequired,
}
const mapStateToProps = state => {
  return {
    loginErrorMessages: state.loginForm.loginErrorMessages,
    challenge: state.loginForm.challenge || null,
    username: state.loginForm.username,
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    loginWatcher
    // add other watcher sagas to this object to map them to props
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);